export enum ReportsQuestionaireRoutes {
    questionareDetail = "details-reports",
    qChannel = "channel-reports"
}

export enum ReportsQuestionairePermissions {
    questionareDetail = "",
    qChannel = "Questionare Detail"
}
